import * as React from 'react';
import { Link, Route, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';

interface INavLinkProps {
  exact?: boolean;
  submenu?: boolean;
  to: string;
  parent?: string;
  className?: string;
  children: string;
}

const StyledLink = styled(Link)`
  border-color: transparent;
  &:hover,
  &.active {
    border-color: ${(props) => props.theme.primary};
  }
`;

class NavLink extends React.Component<INavLinkProps> {
  renderLink = ({ match }: RouteComponentProps) => (
    <StyledLink
      className={`${
        this.props.submenu ? 'block py-2 hover:bg-grey-light' : 'pt-3 pb-1'
      } text-black border-b-2 ${this.props.className || ''} ${
        match ? 'active' : ''
      }`}
      to={this.props.to}
    >
      {this.props.children}
    </StyledLink>
  );

  render() {
    const { exact, to, parent } = this.props;
    return (
      <Route exact={exact} path={parent || to} children={this.renderLink} />
    );
  }
}

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/Header/components/NavLink.tsx